<div class="mc-topbar">

  <!-- Solo mobile, y solo fuera del Resumen. -->
  <button class="mc-volver" *ngIf="mostrarVolver" (click)="volver()" aria-label="Volver">
    <mat-icon>chevron_left</mat-icon>
  </button>

  <!-- El logo del prototipo era un circulo dibujado con CSS mas la palabra
       "puppis" en texto. Se usa el logo real de la app. -->
  <a class="mc-brand" [routerLink]="['/home']">
    <img src="/assets/images/logo_puppis.png" alt="Puppis">
  </a>

  <nav class="mc-topnav">
    <a *ngFor="let e of enlaces" [href]="e.url" target="_blank" rel="noopener noreferrer">
      {{ e.texto }}
    </a>
  </nav>

  <span class="mc-sep"></span>

  <a class="mc-userbtn" [routerLink]="['/edit-customer']" *ngIf="nombre">
    <span class="mc-avatar">{{ iniciales }}</span>
    <span class="mc-username">{{ nombre }}</span>
  </a>

</div>
